export class ReportClass {
  EnterPrise: boolean;
  Type:string
  Hotel: boolean;
  NonHotel: boolean;
  ZeroCostSubscription: boolean;
  EntityStatus: string;
  BookindDate: any;
  BookingDateValue: string ;
  MonthalySubStartDate: any;
  Bussinessaccount: any;
  SubscriptionStatus: string;
  MonthlysubscriptionDate: any;
  OrganizationRunDate: any;
  OrganizationStatus: string;
  DateFrom: any;
  DateTo: any;
  IsRunByBookingDTEnable: boolean;
  BookingFrom: any;
  BookingTo: any;
  SubscriptionVersionStatus: any;
  AccountExecutive: any = '';
}



// WEBPACK FOOTER //
// ./src/app/Classes/ReportClass.ts